module.exports = __webpack_public_path__ + "img/test03-3.f08d0601.jpg";